"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var file_selector_1 = require("./file-selector");
exports.fromEvent = file_selector_1.fromEvent;
//# sourceMappingURL=index.js.map